
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnPlay extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 88.5, y ?? 88.5);

    // btn_play_png
    const btn_play_png = scene.add.image(0, 0, "title", "btn-play-title.png");
    this.add(btn_play_png);

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.shouldPulse = true;
    thisUIButton.pulseScaleEnd = 1.1;
    thisUIButton.pulseSpeed = 1000;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
